// extracted by mini-css-extract-plugin
export default {"pageLayout":"IndexGroup-module__pageLayout___zUqQw"};